import {connect} from 'react-redux';
import {bindActionCreators, type Dispatch} from 'redux';

import {createSelector} from 'reselect';

import {removeReaction} from 'mattermost-redux/actions/posts';

import {canAddReactions, canRemoveReactions} from 'mattermost-redux/selectors/entities/reactions';
import {getCurrentUserId} from 'mattermost-redux/selectors/entities/users';

import {openModal} from 'actions/views/modals';

import {type GenericAction} from 'mattermost-redux/types/actions';
import {getChannel, getMyChannelMemberships} from 'mattermost-redux/selectors/entities/channels';
import {type Post} from 'mattermost-redux/types/posts';
import {type Reaction as ReactionType} from 'mattermost-redux/types/reactions';
import {type GlobalState} from 'types/store';

import {addReaction, addReactionToPost} from 'actions/post_actions';
import {getEmojiUrlByName} from 'utils/emoji_utils';

import {fetchUsersByIdsDebounced} from 'features/users/actions/fetch_users_by_ids';

import {isOpenChannel} from 'utils/isOpenChannel';
import {isPrivateChannel} from 'utils/isPrivateChannel';

import Reaction from './reaction';

type Props = {
    emojiName: string;
    post: Post;
    reactions: ReactionType[];
};

function makeMapStateToProps() {
    const didCurrentUserReact = createSelector(
        getCurrentUserId,
        (state: GlobalState, reactions: ReactionType[]) => reactions,
        (currentUserId: string, reactions: ReactionType[]) => {
            return reactions.some((reaction) => reaction.user_id === currentUserId);
        },
    );

    return function mapStateToProps(state: GlobalState, ownProps: Props) {
        const channelId = ownProps.post.channel_id;
        const channel = getChannel(state, channelId);
        const isChannelWithReactionsModal = channel &&
            ((isOpenChannel(channel) && getMyChannelMemberships(state)[channel.id]) || isPrivateChannel(channel));

        const emojiImageUrl = getEmojiUrlByName(state, ownProps.emojiName);
        const currentUserId = getCurrentUserId(state);

        return {
            currentUserId,
            hasReactionsModal: isChannelWithReactionsModal,
            reactionCount: ownProps.reactions.length,
            canAddReactions: canAddReactions(state, channelId),
            canRemoveReactions: canRemoveReactions(state, channelId),
            emojiImageUrl,
            currentUserReacted: didCurrentUserReact(state, ownProps.reactions),
        };
    };
}

function mapDispatchToProps(dispatch: Dispatch<GenericAction>) {
    return {
        actions: bindActionCreators({
            addReaction,
            addReactionToPost,
            removeReaction,
            openModal,
            fetchUsersByIdsDebounced,
        }, dispatch),
    };
}

export default connect(makeMapStateToProps, mapDispatchToProps)(Reaction);
